module.exports = require("core-js/library/fn/is-iterable");